module.exports = __webpack_public_path__ + "img/RQ.b2b2b31a.png";